import * as React from 'react'
import { action } from 'mobx'
import { observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import {
    UILoginFormSchema,
    transformErrors,
    loginFormSchema
} from '../../../Model/LoginForm'
import HttpActionsService from '../../../Services/HttpActionsService'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import { Button } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import LanguageSelectorView from '../LanguageSelector/view'
// import FooterView from './FooterView'

export interface ILoginFormProps {
    localizationStore?: LocalizationStore,
    httpActionsService?: HttpActionsService
}

@observer
export default class LoginForm extends React.Component<ILoginFormProps> {
    uiSchema: any = UILoginFormSchema

    constructor(props: any) {
        super(props)
    }

    @action.bound
    setLanguage(key: 'RU' | 'EN' | 'AZ') {
        LocalizationStore.getInstance().setLanguage(key)
    }

    login(e: ISubmitEvent<any>): void {
        HttpActionsService.getInstance().login(
            e.formData['email'],
            e.formData['password']
        )
    }

    render() {
        const ls = LocalizationStore.getInstance()
        const self = this

        return (
            <div className="container loginFormContainer">
                <div className="row loginFormWrapper">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-12">
                        <LanguageSelectorView setLanguage={this.setLanguage!} />
                        <Form
                            onSubmit={(e) => self.login(e)}
                            schema={loginFormSchema()}
                            uiSchema={this.uiSchema}
                            transformErrors={transformErrors}
                        >
                            <div className="loginFormButtons">
                                <Button type="submit">{ls.t!('LoginBtn')}</Button>
                                <NavLink to="/resetPassword">{ls.t('ForgotPasswordLink')}</NavLink>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Account/LoginForm.tsx